import React from 'react';

export default function XrayGlassesSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className}>
      <polygon points="30.94,24.57 2.0,24.57 2.0,13.71 30.94,13.71" fill="#714646" />
      <polygon points="9.06,26.29 2.0,22.76 2.0,17.33 9.06,20.86" fill="#321E1E" opacity="0.95" />
      <polygon points="38.0,26.29 30.94,22.76 30.94,17.33 38.0,20.86" fill="#321E1E" opacity="0.95" />
    </svg>
  );
}
